import Link   from '../components/link';
import Navbar from '../components/navbar';
import React  from 'react';


export default function HelpPage() {
  return (
    <React.Fragment>
      <Navbar title="Help"/>
      <div className="page-content help">
        <div className="block inset">
          <p className="margin-bottom">
            With Broadly, you have several ways to get help!
          </p>
          <ul className="margin-bottom">
            <li>Visit the <Link href="https://broadlyhelp.force.com/s/" external>Broadly Support Center</Link> for FAQs and a Quickstart Guide</li>
            <li>Chat with us at <Link href="https://broadly.com" external>broadly.com</Link></li>
            <li>Email us at <Link href="mailto:support@broadly.com" target="_self" external>
            support@broadly.com</Link></li>
            <li>Call us at <Link href="tel:1-800-727-0445" target="_self" external>1-800-727-0445</Link></li>
          </ul>
          <p>Please note that our support hours are Monday-Friday from 5am - 5pm Pacific Time.</p>
        </div>
      </div>
    </React.Fragment>
  );
}
